export const fontFamilyRegular = 'Poppins-Regular';
export const fontFamilySemiBold = 'Poppins-SemiBold';
export const fontFamilyBold = 'Poppins-Bold';
